import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  HostBinding
} from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'search-preview',
  templateUrl: 'search-preview.component.html',
  styleUrls: ['search-preview.component.scss']
})
export class SearchPreviewComponent {

  @HostBinding('class.search-preview-minimized')
  @Input() minimized: boolean = false;

  @HostBinding('class.with-list-icon')
  @Input() withList: boolean = false;

  @Input() listIsShown: boolean = false;

  @Input() filters: Array<any>;

  @HostBinding('class.has-advanced-search')
  @Input() hasAdvancedSearch: boolean = false;

  @Input() searchKeyword: string;

  @Input() ghostValue: string;

  @Input() actions: Array<any> = [];

  @Input() showActionsDropdown: boolean = true; // show or not actions dropdown

  @Input() placeholder: string = 'Search for a product by name or other information…';

  @Input() searchByCall: boolean = false;

  @Input() hideSearch: boolean = false;

  @Input() searchIconColor: string = 'white';
  @Input() closeIconClass: string = 'close-white-icon';

  @HostBinding('class.has-search-keyword') get hasSearchKeyword(): boolean {
    return !!this.searchKeyword;
  }

  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();

  @Output() searchPreviewClick: EventEmitter<any> = new EventEmitter();

  @Output() filterRemoved: EventEmitter<any> = new EventEmitter();

  @Output() listIconClick: EventEmitter<boolean> = new EventEmitter();

  @Output() advancedSearchClick: EventEmitter<boolean> = new EventEmitter();

  @Output() actionSelect: EventEmitter<boolean> = new EventEmitter();

  @HostBinding('class.filtered')
  get hasFilters(): boolean {
    return this.filters && this.filters.length > 0;
  }

  @HostBinding('class.has-actions')
  get hasActions(): boolean {
    return this.actions.length > 0;
  }

  onClearSearchClick() {
    this.clearSearchClick.emit();
  }

  onSearchPreviewClick() {
    this.searchPreviewClick.emit();
  }

  onListIconClick() {
    this.listIconClick.emit();
  }

  onFilterRemove($event: any) {
    this.filterRemoved.emit($event);
  }

  onAdvancedSearchClick() {
    this.advancedSearchClick.emit();
  }

  onActionSelect($event: any) {
    this.actionSelect.emit($event);
  }
}
